import { ServiceContainerDto } from "@apiModels/ServiceContainerDto.csharp";
import { useEffect, useState } from "react";
import { LocationDto } from "@apiModels/LocationDto.csharp";
import { DoctorDto } from "@apiModels/DoctorDto.csharp";
import { haveCommonElements } from "../Helpers";

export const useFilteredLocations = (
  locations: LocationDto[],
  service: ServiceContainerDto,
  forcedDoctor?: DoctorDto
) => {
  const [filteredItems, setFilteredItems] = useState<LocationDto[]>([]);
  const [otherItems, setOtherItems] = useState<LocationDto[]>([]);

  useEffect(() => {
    const getSupportedLocationsIds = () => {
      if (service.id) {
        return service.centerBookingOptions.map((center) => center.centerId);
      }
      return [];
    };

    let filteredLocations = locations.filter((location) => {
      if (location.excludeFromListings) {
        if (!service.id) {
          return false;
        }
        return location.specializations.some(
          (specializationId) => service.specializationId === specializationId
        );
      }
      return true;
    });

    if (service.id) {
      const supportedLocationsIds = getSupportedLocationsIds();
      filteredLocations = filteredLocations.filter((loc) => {
        if (loc.isLocation === false) {
          return supportedLocationsIds.includes(loc.id);
        }
        return loc.centers.some((lc) => supportedLocationsIds.includes(lc));
      });
    }

    if (forcedDoctor) {
      filteredLocations = filteredLocations.filter(
        (loc) =>
          (loc.isLocation &&
            haveCommonElements(loc.centers, forcedDoctor.centers)) ||
          forcedDoctor.centers.indexOf(loc.id) != -1
      );
    }

    setFilteredItems(filteredLocations);

    if (service.id) {
      const unavailable = locations
        .filter((l) => !l.excludeFromListings)
        .filter(
          (l) =>
            service.centerBookingOptions.some((cbo) => cbo.centerId == l.id) ==
            false
        )
        .filter((l) => l.isLocation == false);
      setOtherItems(unavailable);
    } else {
      const unavailable = filteredLocations
        .filter((l) => filteredLocations.indexOf(l) == -1)
        .filter((l) => l.isLocation == false);
      setOtherItems(unavailable);
    }
  }, [service, forcedDoctor]);

  return {
    filteredLocations: filteredItems,
    unavailableLocations: otherItems,
  };
};
